<template>

  <section class="ContentSectionWithHotspotGraphic">

    <Container>
      <CenteredTextBox :content="content" />
    </Container>

    <HotspotGraphic v-if="content.hotspotGraphic"
      :content="content.hotspotGraphic"
      class="hotspotGraphic"
    />

  </section>

</template>

<script setup>
import CenteredTextBox from './blocks/CenteredTextBox.vue'
import HotspotGraphic from '../HotspotGraphic/index.vue'

const { content } = defineProps({ content: Object })
</script>

<style scoped>
.ContentSectionWithHotspotGraphic {
  padding-top: var(--spacing-15);
  padding-bottom: var(--spacing-11);
  background-color: var(--bg-color-white);
}
.hotspotGraphic {
  margin-top: var(--spacing-15);
}
</style>
